import React, { useState } from "react";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { FeedbackDialog } from "../../../../shared/components/FeedbackDialog";

interface Props {
  data: {
    message?: string;
  };
}

export const FeedbackFormWidget: React.FC<Props> = ({ data }) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div className="bg-card rounded-xl border-2 border-border/50 p-4 mt-2 shadow-sm">
        {data?.message && (
          <p className="text-sm text-muted-foreground mb-3">{data.message}</p>
        )}
        <button
          onClick={() => setShowDialog(true)}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm rounded-full hover:bg-primary/90 transition-all shadow-sm"
        >
          <ChatBubbleLeftIcon className="h-4 w-4" />
          Submit Feedback
        </button>
      </div>
      <FeedbackDialog open={showDialog} onClose={() => setShowDialog(false)} />
    </>
  );
};
